import React from "react"
import Slider from "react-slick"
import Svg from "../_svgs/svg"
import "./_value-card.scss"
import useWindowWidth from "../../hooks/useWindowWidth"

export default function ValueCardsContainer({ contentArea }) {
  const valueCards = contentArea || []
  const windowWidth = useWindowWidth()

  var settings = {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    variableWidth: false,
  }

  if (windowWidth >= 768 && windowWidth < 920) {
    settings.slidesToShow = 2
  }

  return (
    <section className="value-cards-container">
      <div className="w--narrow">
        {windowWidth >= 768 ? (
          valueCards.length > 0 ? (
            valueCards.map((card) => {
              return (
                <ValueCard
                  key={card.header}
                  icon={card.icon[0] || null}
                  iconUpload={card.iconUpload}
                  header={card.header}
                  description={card.description}
                />
              )
            })
          ) : null
        ) : (
          <Slider {...settings}>
            {valueCards.length > 0
              ? valueCards.map((card) => {
                  return (
                    <ValueCard
                      key={card.header}
                      icon={card.icon[0] || null}
                      iconUpload={card.iconUpload}
                      header={card.header}
                      description={card.description}
                    />
                  )
                })
              : null}
          </Slider>
        )}
      </div>
    </section>
  )
}

function ValueCard({ icon, iconUpload, header, description }) {
  const svg = icon?.value || undefined

  return (
    <div className="card-container">
      <article className="value-card">
        {svg !== "None" || undefined ? (
          <Svg iconName={svg} fillColor={"transparent"} stroke={"#000"} key={svg}></Svg>
        ) : iconUpload ? (
          <div className="icon">
            <img src={iconUpload}></img>
          </div>
        ) : (
          ""
        )}
        <h3>{header}</h3>
        <p>{description}</p>
      </article>
    </div>
  )
}
